// Shared brand content for London's Loft of Lyfe™

export const IMAGES = {
  founder: "https://static.prod-images.emergentagent.com/jobs/3a2a8b29-0e1c-48ab-a5c4-a45b0d40fd4b/images/f13f9525971dea31290cf51076bc2712f46c1832dbc16e11a5c347923073a612.png",
  heroLoft: "https://static.prod-images.emergentagent.com/jobs/3a2a8b29-0e1c-48ab-a5c4-a45b0d40fd4b/images/07ca88b0688c8f42669bbc193c7dabb148fe1921c33dbf2fd4618f965004c48f.png",
  emblem: "/brand/logo.png",
  loftBright: "https://static.prod-images.emergentagent.com/jobs/3a2a8b29-0e1c-48ab-a5c4-a45b0d40fd4b/images/07ca88b0688c8f42669bbc193c7dabb148fe1921c33dbf2fd4618f965004c48f.png",
  loftBrick: "https://images.unsplash.com/photo-1611048267451-e6ed903d4a38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  lotus: "https://images.pexels.com/photos/32289181/pexels-photo-32289181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  lotusLeaves: "https://images.pexels.com/photos/12784471/pexels-photo-12784471.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  lighthouse: "https://images.unsplash.com/photo-1544954582-d6e00b25d3df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  meditationGroup: "https://images.pexels.com/photos/8436725/pexels-photo-8436725.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  meditationOutdoor: "https://images.pexels.com/photos/7078131/pexels-photo-7078131.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  journal: "https://images.pexels.com/photos/3975575/pexels-photo-3975575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

export const PILLARS = [
  {
    key: "london",
    letter: "L",
    name: "London",
    motif: "crown",
    color: "#C4A2E8",
    title: "Identity, heritage, purpose & legacy",
    text: "We begin with who you are. London honors your roots, your story, and the legacy you are called to build.",
  },
  {
    key: "loft",
    letter: "L",
    name: "Loft",
    motif: "loft",
    color: "#C4A2E8",
    title: "Vision, elevation & new perspectives",
    text: "Rise above the noise. The Loft is a place of clarity, elevation, and a wider view of what's possible.",
  },
  {
    key: "lyfe",
    letter: "L",
    name: "Lyfe",
    motif: "leaf",
    color: "#4FD6AD",
    title: "Intentional living, wellness & abundance",
    text: "Live on purpose. Lyfe is about wellbeing, rhythm, and creating a life of genuine abundance.",
  },
  {
    key: "lotus",
    letter: "L",
    name: "Lotus",
    motif: "lotus",
    color: "#C4A2E8",
    title: "Healing, resilience & transformation",
    text: "The lotus blooms from still waters. Here we heal, build resilience, and transform with compassion.",
  },
  {
    key: "lighthouse",
    letter: "L",
    name: "Lighthouse",
    motif: "lighthouse",
    color: "#C4A2E8",
    title: "Guidance, leadership & illumination",
    text: "Become the light. The Lighthouse is our calling to guide, lead, and illuminate the path for others.",
  },
];

export const METHOD_STEPS = [
  { word: "Bloom", pillar: "Lotus", text: "Heal what's been held and begin again — softly, fully, on your own terms." },
  { word: "Illuminate", pillar: "Lighthouse", text: "Find clarity and direction. See your purpose clearly and let it guide your steps." },
  { word: "Elevate", pillar: "Loft", text: "Rise into new perspectives and possibilities. Expand what you believe you can do." },
  { word: "Legacy", pillar: "London", text: "Build something that outlasts you — rooted in identity, heritage, and purpose." },
  { word: "Live", pillar: "Lyfe", text: "Live intentionally and abundantly, with wellness woven into everything you do." },
];

export const SERVICES = [
  {
    key: "grow",
    name: "Grow",
    motif: "lotus",
    color: "#C4A2E8",
    tagline: "Heal, learn & develop",
    items: ["Educational resources", "Family wellness", "Personal development"],
    desc: "Nurturing programs and resources for families, educators, and individuals ready to heal and learn.",
  },
  {
    key: "build",
    name: "Build",
    motif: "lighthouse",
    color: "#4FD6AD",
    tagline: "Strategy, systems & scale",
    items: ["Business consulting", "AI automation", "Systems & strategy"],
    desc: "Soul-led business strategy, AI automation, and systems that protect your energy while you scale.",
  },
  {
    key: "thrive",
    name: "Thrive",
    motif: "crown",
    color: "#C4A2E8",
    tagline: "Coaching & transformation",
    items: ["Coaching", "Consulting", "Leadership development", "Transformational support"],
    desc: "Deep, compassionate coaching and leadership development for lasting transformation.",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Shantel" },
  { to: "/method", label: "The 5L Method" },
  { to: "/services", label: "Services" },
  { to: "/resources", label: "Resources" },
  { to: "/community", label: "Community" },
  { to: "/journal", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export const MEMBERSHIP_TIERS = [
  {
    name: "Seeker",
    price: "Free",
    period: "",
    highlight: false,
    perks: ["Monthly newsletter", "Access to the Journal", "Community announcements"],
    cta: "Join Free",
  },
  {
    name: "Bloom Circle",
    price: "$29",
    period: "/month",
    highlight: true,
    perks: ["Everything in Seeker", "Live monthly circles", "Full resource library", "Private community access", "Early access to courses"],
    cta: "Become a Member",
  },
  {
    name: "Legacy Collective",
    price: "$89",
    period: "/month",
    highlight: false,
    perks: ["Everything in Bloom Circle", "Quarterly 1:1 strategy call", "Business & AI toolkits", "Certification pathway access"],
    cta: "Apply Now",
  },
];
